﻿import React from 'react';
//import PropTypes from 'prop-types';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

// i'm so sorry about this shitty code :(
const RadioButton = ({ error, isChanged, isUsed, ...allProps }) => {
    const {
        displayname,
        layout,
        theme,
        errorColor,
        textColor,
        uncheckable,
        customwidth,
        customdisplay,
        marginbottom,
        errorMessageDisplayNone,
        ...props
    } = {...allProps};

    const untoggleRadio = () => {
        // If user clicks checked radio-button, uncheck it
        let inp = document.getElementById(radioRef.id);
        if (inp.checked) {
            setTimeout(() => inp.checked = false, 66);
        }
    };

    let labelRef = null;
    let radioRef = null;

    return (
        <RadioWrapper
            layout={layout}
            theme={theme}
            displayname={displayname}
            customwidth={customwidth}
            customdisplay={customdisplay}
            marginbottom={marginbottom} 
            errorColor={errorColor}
            errorMessageDisplayNone={errorMessageDisplayNone}
        >
            <input
                aria-labelledby={`${props.id}-radiolabel ${props.id}-hiddenlabel`}
                type="radio"
                ref={el => radioRef = el}
                {...props}
                {...(isChanged && isUsed && error ?
                {
                    className: `is-invalid-input ${props.className}`
                } : {
                     className: props.className
                })}
            />
            <label
                id={`${props.id}-hiddenlabel`}
                ref={el => labelRef = el}
                onClick={uncheckable ? untoggleRadio : () => 0}
                htmlFor={props.id}
            >
                {theme !== 'big' &&
                    <RadioLabel textColor={textColor} aria-label={displayname} className="radiolabel" id={`${props.id}-radiolabel`} customdisplay={customdisplay}>{displayname}</RadioLabel>
                }
                {theme === 'big' &&
                    <span id={`${props.id}-radiolabel`} className="visually-hidden">{displayname}</span>
            }

                &nbsp;
            </label>

            {isChanged && isUsed && error}
        </RadioWrapper>
    );
};

export default control(RadioButton);

const wrapperPropsToExclude = ['layout', 'customdisplay', 'errorMessageDisplayNone', 'marginbottom', 'errorColor', 'theme', 'customwidth' ];

// styled components
const RadioWrapper = styled.div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !wrapperPropsToExclude.includes(prop)
})`
    position: relative;
    display: ${props => props.layout == 'inline' ? 'inline-block' : 'block'};

    line-height: 1;

    // ie/edge fix
    ${'' /* line-height: 0; */}

    ${props => props.customdisplay ? `
        ${mediaQuery.medium(`
            display: ${props.customdisplay};
        `)}
    ` : ``
    }


    ${props => props.errorMessageDisplayNone ? `
        ${mediaQuery.small(`
            span.form-error {
                display: none;
            }
        `)}
    ` : ``
    }

    ${props => props.marginbottom ? `
        ${mediaQuery.medium(`
            margin-bottom: ${props.marginbottom};
        `)}
    ` : `
        ${mediaQuery.medium(`
            margin-bottom: 0px;
        `)}
    `}

    &:not(:first-of-type) {
        margin-left: ${props => props.layout == 'inline' ? '35px' : '0'};
        ${mediaQuery.small(`
            margin-left: 0px;
        `)}
    }

    // only show error for first of type in case this a radio button series
    &:not(:first-of-type) {
        span.form-error {
            opacity: 0;
        }
    }

    span.form-error {
        color: ${props => props.errorColor ? props.errorColor : definitions.colors.error};
    }

    input[type=radio] {
        position: absolute;
        opacity: 0;
    }

    input[type=radio] + label {
        cursor: pointer;
        padding: 0;
        display: block;
        padding-left: 30px;
    }

    // hide regular label, but only half-way for accessibility reasons
    input[type=radio].is-invalid-input + label,
    input[type=radio].is-invalid-input ~ .radiolabel { // see <RadioLabel> below
        margin-bottom: 0;
        color: ${props => props.errorColor ? props.errorColor : definitions.colors.error};
    }

    input[type=radio].is-invalid-input + label:before {
        border-color: ${props => props.errorColor ? props.errorColor : definitions.colors.error};
        background-color: white;
        margin-bottom: 0;
    }

    input[type=radio]:focus:not(:checked) + label:before {
        outline: rgb(59, 153, 252) auto 5px;
    }

    input[type=radio]:checked + label:after {
        position: absolute;
        content: '';

        height: 10px;
        width: 10px;

        border-radius: 5px;
        background-color: ${definitions.colors.green};

        left: 5px;
        top: 10px;
        transform: translateY(-50%);
    }

    label:before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;

        vertical-align: sub; //text-top;
        margin-right: 10px;
        ${mediaQuery.small(`
            margin-right: 10px;
        `)}

        width: 20px;
        height: 20px;

        background: #f5f4f4;
        border: 1px solid #c5c9cc;
        border-radius: 10px;
    }

    // theme: big
    ${props => props.theme === 'big' ? `
        // min-height: 150px;

        &:not(:first-of-type) {
            padding-left: 10px !important;
        }

        // ${mediaQuery.small(`
        //     min-height: 103px;
        // `)}

        input[type=radio] + label {
            padding-left: 0;
        }


        input[type=radio]:focus + label:before {
            outline: none;
        }

        input[type=radio]:focus:not(:checked) + label:before {
            outline: none;
            box-shadow: inset 0px 0px 1px 1px rgb(59, 153, 252);
        }

        label:before {
            display: inline-block;
            content: '${props.displayname}';
            position: relative;

            width: auto;
            height: auto;
            // max-height: 70px;
            padding: 34px 53px;
            margin-bottom: 26px;
            margin-right: 10px;
            line-height: 1;

            font-family: ${definitions.fonts.heading};
            font-size: 22px;
            font-weight: bold;
            color: ${definitions.colors.almostBlack};

            background: transparent;
            border: none;
            border-radius: 0;
            outline: 1px solid ${definitions.colors.grayBorder};

            transition: outline 150ms ease-out, color 150ms ease-out;

            ${mediaQuery.small(`
                padding: 10px 15px 10px 15px;
                font-size: 20px;
                margin-bottom: 15px;
            `)}
        }

        input[type=radio]:checked + label:before {
            outline: 3px solid ${definitions.colors.green};
            color: ${definitions.colors.green};
        }

        input[type=radio]:checked + label:after {
            display: none;
        }

        .form-error {
            text-align: left;
            margin-top: 10px;

        }` : ''
    }

    ${props => props.customwidth ? `
        ${mediaQuery.small(`
            width: ${props.customwidth};
        `)}
    ` : `
        ${mediaQuery.small(`
            width: 176px;
        `)}
    `
    }
`;

const radioPropsToExclude = ['textColor', 'customdisplay'];

const RadioLabel = styled.div.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !radioPropsToExclude.includes(prop)
})`
    display: inline-block;
    font-size: 16px;
    hyphens: auto;
    color: ${props => props.textColor ? props.textColor : 'black'};
    cursor: pointer;
    pointer-events: none;
    padding-top: 2px;

    ${mediaQuery.small(`
        padding-top: 4px;
        font-size: 13px;
    `)}
    cursor: pointer;

    ${props => props.customdisplay ? `
        display: ${props.customdisplay};
    ` : ``
    }
`;
